import React from "react";
import { MaterialReactTable } from "material-react-table";
import "../css/table.min.css";

const CustomTable = ({
  noWrap,
  columns,
  data,
  enableSorting = false,
  enableFilterMatchHighlighting = true,
  enableGlobalFilter,
  enableTopToolbar,
  enableColumnActions = false,
  enableDensityToggle = false,
  enableColumnFilters = false,
  enableFullScreenToggle = false,
  enableHiding = false,
  positionGlobalFilter = "left",
  enablePagination = true,
  enableBottomToolbar = true,
  columnVisibility,
  setColumnVisibility,
  setColumnOrder,
  columnOrder,
  loading,
  ...props
}) => {
  return (
    <div className={`table-wrapper ${noWrap ? "nowrap" : "wrap"}`}>
      <MaterialReactTable
        {...props}
        enableStickyHeader
        dense
        autoResetAll={false}
        columns={columns}
        data={data}
        enableDensityToggle={enableDensityToggle}
        enableHiding={enableHiding}
        enablePagination={enablePagination}
        enableFullScreenToggle={enableFullScreenToggle}
        enableColumnFilters={enableColumnFilters}
        enableColumnActions={enableColumnActions}
        enableBottomToolbar={enableBottomToolbar}
        enableSorting={true}
        enableTopToolbar={enableTopToolbar || false}
        enableGlobalFilter={true}
        enableFilterMatchHighlighting={true}
        positionGlobalFilter="left"
        state={{
          columnVisibility: columnVisibility,
          // columnOrder: columnOrder,
          showProgressBars: loading,
        }}
        // onColumnOrderChange={setColumnOrder}
        onColumnVisibilityChange={setColumnVisibility}
        muiSearchTextFieldProps={{
          placeholder: `Search ${data ? data?.length : 0} rows`,
          sx: { minWidth: "300px" },
          variant: "outlined",
        }}
        muiPaginationProps={{
          rowsPerPageOptions: [5, 10, 20],
        }}
        initialState={{
          columnVisibility: columnVisibility,
          showGlobalFilter: enableGlobalFilter,
        }}
      />
    </div>
  );
};

export default CustomTable;
